import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ValidationService } from '../../services/validation.service';
import { PagerService } from '../../services/index';
import { CookieService } from 'ngx-cookie-service';
import * as moment from 'moment';
import * as $ from 'jquery/dist/jquery.min.js';
declare var jQuery: any;
declare let paypal: any;

@Component({
  selector: 'app-group-list',
  templateUrl: './redeem-list.component.html',
  styleUrls: ['./redeem-list.component.css']
})
export class RedeemListComponent implements OnInit {

  groupList: any = [];
  pager: any = {};
  pagedItems: any[];
  total: any;
  limit: any;
  pageNo: any;
  url: any;
  isSurveyAvailable: boolean = false;
  redirectUrl: any;
  activePageNo: number = 0;
  my_group_list = [];
  selected_group_id = null;
  bankInfo=null;
  selected_group_name = null;
  searchStr = null;
  group_description = null;
  moment: any = moment;
  yearList: any;



  // Paypal Variables
  public didPaypalScriptLoad: boolean = false;
  public loading: boolean = true;
  public paymentAmount: number = 0;
  paypalPaymentData: any;
  curObj: any;

  public paypalConfig: any = {
    env: '',
    style: {
      label: 'buynow',
      // fundingicons: true, // optional
      branding: true, // optional
      size: 'small', // small | medium | large | responsive
      shape: 'rect',   // pill | rect
      color: 'blue'   // gold | blue | silver | black
    },
    //AWlMGZwpQbS0dq_r2Dt0ejp1TxDm72JD7Pt4Uc2mYlihAE3FU5axxS9wr4HcnVc13gB7TcbYDVLp9Vne
    client: {},
    commit: true,
    payment: (data, actions) => {
      return actions.payment.create({
        payment: {
          transactions: [
            { amount: { total: 1, currency: 'USD' } }
            // { amount: { total: this.paidAmount, currency: 'USD' } }
          ]
        },

        experience: {
          input_fields: {
            no_shipping: 1
          }
        },
      });
    },
    onAuthorize: (data, actions) => {
      let that = this;
      return actions.payment.execute().then((payment) => {
        console.log("payment", payment)
        // if (payment.state == 'approved' || payment.state == 'pending') {
        // 	that.newSurveyData.transaction_source = 'Paypal',
        // 		that.newSurveyData.amount = this.paidAmount;
        // 	that.newSurveyData.transaction_status = payment.state;
        // 	that.newSurveyData.transaction_details = payment;
        // 	that.newSurveyData.amount_key = this.amountKey;
        // 	that.postSurvey(that.newSurveyData, that.newSurveyOptions);
        // }
        // else {
        // 	this.isValidScore = false;
        // 	this.scoreMsg = "Transaction failed. please try again later...";
        // }
      });
    },

    validate: function (actions) {
    },

    onCancel: function (data, actions) {
      // Show a cancel page or return to cart
    },

    onError: function (err) {
      // this.isValidScore = false;
      // this.scoreMsg = "Transaction failed. please try again later...";
    },

    onClick: function (e) {
    }

  }

  constructor(private commonService: CommonService, private authService: AuthService,
    private router: Router, private validationService: ValidationService,
    private pagerService: PagerService, private cookieService: CookieService) { }

  ngOnInit() {
    this.commonService.loadScript();
    this.initialiseSurvey();
    this.commonService.process();
    this.curObj = this;

  }

  //Search Users
  searchUser = function () {
    this.limit = 10;
    this.pageNo = 1;
    var redeemType =  $('#redeemType').val();
    var redeemStatus =  $('#redeemStatus').val();
    var selectedMonth =  $('#selectedMonth').val();
    var yearData = $('#yearData').val();

		var param = `&&redeemType=`+redeemType+`&&redeemStatus=`+redeemStatus+`&&selectedMonth=`+selectedMonth+`&&yearData=`+yearData;
    this.getRedeemList(this.pageNo, this.limit, param);
  }

  // Get Survey List
  initialiseSurvey = function () {
    $('#paypalLink').css('display', '').show();
    this.getPaypalConfigurationData();

    $('.navbar-brand').text('Redeem List');
    this.commonService.setTitle();
    this.limit = 10;
    this.pageNo = 1;

    let route = this.router.url;
    this.authService.getYearList().subscribe(data => {
			if (data.success) {

				this.yearList = data.year;
			}
		});
    if (route.indexOf("?") !== -1) {
      var routeArr = route.split('?backUrl=');
      var decodedUri = decodeURIComponent(routeArr[1]);
      var decodedArr = decodedUri.split("&");
      var decodedPageNo = decodedArr[0].split("pageNo=");

      this.pageNo = decodedPageNo[1];
      this.activePageNo = decodedPageNo[1];

      var decodedSearchStr = decodedArr[1].split("searchStr=");
      this.searchStr_back = decodedSearchStr[1];
      $(".navbar-brand").text("Group Surveys");
    }

    // Get groups list
    this.getRedeemList(this.pageNo, this.limit);
  }

  // Get group survey list
  getRedeemList = function (pageNo, limit, params="") {
    // debugger;;
    $("#search").val(this.searchStr_back ? this.searchStr_back : $('#search').val());
    this.searchStr_back = null;
    var searchStr = $('#search').val();
    this.commonService.process();
    this.authService.getRedeemListinAdmin(pageNo, limit, searchStr,params).subscribe(data => {
      console.log("data", data)
      if (data.success) {
        var that = this;
        if (pageNo == this.activePageNo)
          setTimeout(function () {
            $('#page_' + that.activePageNo).addClass('active');
            if (that.activePageNo == 1)
              $('#first, #prev').addClass('disabled');
            else if (that.activePageNo == that.pager.totalPages)
              $('#next, #last').addClass('disabled');
          }, 300);
        this.groupList = data.list;
        this.total = data.total;
        this.setPage(pageNo, true);
        this.pageNo = pageNo;
        this.redirectUrl = "pageNo=" + pageNo + "&searchStr=" + searchStr + "&groupList=1";
      }
      else {
        this.groupList = [];
        this.isSurveyAvailable = true;
      }
      this.commonService.hideProcess();
    });
  }

  // Pagination
  setPage(page: number, param) {
    this.pager = this.pagerService.getPager(this.total, page);
    $(this).parent('li').addClass('active');
    $('.pages.active a').each(function () {
      if (parseInt($(this).text()) != page)
        $(this).parent('li').removeClass('active');
    });
    if ($('#first, #prev').hasClass('disabled') && page != this.pager.totalPages && page != 1)
      $('#first, #prev').removeClass('disabled');
    if ($('#next, #last').hasClass('disabled') && page != this.pager.totalPages)
      $('#next, #last').removeClass('disabled');

    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    // get current page of items
    this.pagedItems = this.groupList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    if (!param) {
      this.getRedeemList(page, this.limit);
    }
  }

  // Delete selected Survey Details
  deleteSelectedGroup = function (group) {
    this.selected_group_id = group._id;
    this.selected_group_name = group.group_name;
  }

  payNow = function (data) {
    console.log(data)
    this.commonService.process();
    this.authService.authenticatePaypal().subscribe(dataValue => {
      console.log("dataValue", dataValue)
      if (dataValue.access_token) {
        this.authService.payThroughPaypal(dataValue.access_token).subscribe(status => {
          console.log("status", status)
          if (status.batch_header.batch_status === 'PENDING') {
            this.authService.getPaymentDetail(dataValue.access_token, status.links[0].href).subscribe(result => {
              console.log("result", result)
              if(result.items[0].transaction_status==='SUCCESS'){
                jQuery.growl.notice({ title: 'Success', message: "Payment Successfully Done" });
                this.authService.updateRedeemStatus({query_id:data._id,status:result.items[0].transaction_status,transaction_details:result.items[0]}).subscribe(result => {
                  jQuery.growl.notice({ title: 'Success', message: "Added Transaction detail in server" });
                  this.getRedeemList(this.pageNo, this.limit);

                })
              }
            })
          }
        })
      }
    })
  }
  
  showBankDetail= function (data) {
    console.log("data",data)
    this.bankInfo = data;
  }
  
  showPackage= function (data) {
    console.log("data",data)
   
  }

  // Delete Survey
  deleteGroup = function () {
    if (this.selected_group_id) {
      this.authService.deleteGroup(this.selected_group_id).subscribe(data => {
        if (data.success) {
          this.authService.cancelProcess();
          this.getRedeemList(this.pageNo, this.limit);
          jQuery.growl.notice({ title: 'Success', message: data.message });
        }
        else {
          jQuery.growl.error({ title: 'Error', message: data.error });
        }
        this.selected_group_id = null;
        this.selected_group_name = null;
      });
    }
    else {
      jQuery.growl.error({ title: 'Error', message: "Group must be selected!" });
    }
  }

  showDescription(description) {
    this.group_description = description;
  }

  getPaypalConfigurationData = function () {
    this.authService.getPaypalConfigurationData().subscribe(data => {
      console.log("data,dat", data)
      if (data.success) {
        if (data.paypalConfigList.paypal_mode == "sandbox") {
          this.paypalConfig.env = 'sandbox';
          this.paypalConfig.client = {
            "sandbox": data.paypalConfigList.paypal_key,
          };
        }
        else {
          this.paypalConfig.env = 'production';
          this.paypalConfig.client = {
            "production": data.paypalConfigList.paypal_key,
          };
        }
        if (!this.didPaypalScriptLoad) {
          this.loadPaypalScript().then(() => {
            paypal.Button.render(this.paypalConfig, '#paypal-button');
            this.loading = false;
          });
        }
      }
    });
  }

  public loadPaypalScript(): Promise<any> {
    this.didPaypalScriptLoad = true;
    return new Promise((resolve, reject) => {
      const scriptElement = document.createElement('script');
      scriptElement.src = 'https://www.paypalobjects.com/payouts/js/payouts_aac.js';//'https://www.paypalobjects.com/api/checkout.js';
      scriptElement.onload = resolve;
      document.body.appendChild(scriptElement);
    });
  }
}



// WEBPACK FOOTER //
// /Users/vishitamandloi/Documents/vishitaProjects/waz/angular/adminportal/waz-admin-panel/src/app/dashboard/redeem-list/redeem-list.component.ts